import { useState } from 'react';

/**
 * useFormValidation — required-field validation for a flat form-state object.
 *
 * const { errors, validate, clearError } = useFormValidation({
 *   client_id: { required: true, label: 'Client' },
 *   order_date: { required: true, label: 'Order Date' },
 * });
 * ...
 * if (!validate(form)) return;   // call in the submit handler before posting
 */
export function useFormValidation(rules) {
  const [errors, setErrors] = useState({});

  const validate = (values) => {
    const next = {};
    for (const [field, rule] of Object.entries(rules)) {
      if (!rule.required) continue;
      const v = values[field];
      if (v === '' || v === null || v === undefined) {
        next[field] = `${rule.label || field} is required`;
      }
    }
    setErrors(next);
    return Object.keys(next).length === 0;
  };

  const clearError = (field) => {
    setErrors(prev => (prev[field] ? { ...prev, [field]: undefined } : prev));
  };

  const reset = () => setErrors({});

  return { errors, validate, clearError, reset };
}
